import { Typography, Box } from "@mui/material";
import CustomPagination from "../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function InfoGraphy(props) {
  const { isSmall } = useBreakpoints();

  const columns = [
    {
      field: "id",
      width: 110,
      align: "center",
      headerName: "کد",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "shamsiDate",
      width: 160,
      align: "center",
      headerName: "تاریخ",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiDate}
          </Typography>
        );
      },
    },
    {
      field: "operator",
      headerName: "نام اپراتور",
      width: 200,
      align: "left",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "action",
      headerName: "عملیات",
      width: 170,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },
  ];

  return (
    // <Box sx={{ p: 2, mb: 2 }}>

    <Box sx={{ height: "25rem", width: isSmall ? "100%" : "60%" }}>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        pageSize={100}
        rows={props.orderDetail?.infography ? props.orderDetail.infography : []}
        page={0}
        rowCount={
          props.orderDetail?.infography
            ? props.orderDetail.infography.length
            : 1
        }
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            isLtr: true,
            noPage: true,
            nofab: true,
            rowCount: props.orderDetail?.infography
              ? props.orderDetail.infography.length
              : "",
          },
        }}
      />
    </Box>
    // </Box>
  );
}
